export const ROOT = 'calendar';

export const ADD_DATE_SELECTED = `${ROOT}/ADD_DATE_SELECTED`;
export const ADD_ALL_DATE_SELECTED = `${ROOT}/ADD_ALL_DATE_SELECTED`;
export const DELETE_DATE_SELECTED = `${ROOT}/DELETE_DATE_SELECTED`;
export const DELETE_ALL_DATE_SELECTED = `${ROOT}/DELETE_ALL_DATE_SELECTED`;

export const SET_CALENDAR_DATE = `${ROOT}/SET_CALENDAR_DATE`;

export const CLEAN_ALL_DATE_SELECTED = `${ROOT}/CLEAN_ALL_DATE_SELECTED`;
